module.exports = __webpack_public_path__ + "img/AR837.5f7792d2.png";